import {writable} from 'svelte/store';
import Session from './Session';
import Config from '../Models/Config';
import Helper from '../Models/Helper';

const content = {busy: false};
let api = writable(content);

api.busy = state => {
	content.busy = !!state;
	api.set(content);
};


api.request = async (method, uri, data, load = true) => {
	if(load)
		api.load(true);
	const token = Session.getToken();
	const payload = {method, headers: {}};
	if (token) payload.headers['Authorization'] = `Bearer ${token}`;
	if (Helper.is(data)) {
		payload.headers['Content-Type'] = 'application/json';
		payload.body = JSON.stringify(data);
	}

	let response;
	try {
		const base = Config.api.endpoint;
		const url = `${base}/${uri}`;
		api.busy(true);
		const message = await fetch(url, payload);
		api.busy(false);
		response = await message.json();
		api.set(content);
	}
	catch (error)
		{ response = {success: false, data: error}; }

	if(load)
		setTimeout(() => api.load(false), 300);
	return response;
};

api.write = async (method, uri, data, load = true) => {
	return await api.request(method, uri, data, load);
};

// Authentication

api.signIn = async (data = {mail, password}) => {
	const response = await api.request('post', 'agent/session', data);
	if (response.success) {
		const {id, name, mail, initials} = response.data;
		Session.authentication(response.token);
		Session.user(id, name, mail, initials);
	}

	return response;
};

api.signOut = async () => {
	Session.authentication(false);
};

api.load = (state) => {
	if(state) {
		$('#preloader').show();
		$('#status').show();
	} else {
		$("#status").fadeOut()
		$("#preloader").delay(350).fadeOut("slow")
	}
}



export default api;